export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-low-1200-ca1ad01fec4cab950adaba4ab93a913f.png";